import _ from "lodash";
import axios from "axios";
import { store } from "store/createStore";
import { setUnderMaintenance } from "Login/modules/LoginModule/LoginActions";
import { allowURLWithCredentials } from "Utils/SecureUrlHelpers";

/* 
  Extracted from LoginUtils as LoginUtils depend on axiosInstance
  Top level utility folders need to remain independent if possible 
 */
export const setUnderMaintenanceState = ({ value }) => {
  store.dispatch(setUnderMaintenance(value));
};

// ---------------------------------------------

const axiosInstance = axios.create({
  withCredentials: false,
});

axiosInstance.interceptors.request.use(
  config => {
    config.withCredentials = allowURLWithCredentials(config.url);
    return config;
  },
  error => {
    // Handle request error
    throw error;
  }
);

axiosInstance.interceptors.response.use(
  response => {
    // Handle successful responses
    return response;
  },
  error => {
    const errorId = _.get(error, "response.data.id", null);

    switch (errorId) {
      case "SERVER_UNDER_MAINTENANCE": {
        setUnderMaintenanceState({
          value: _.get(error, "response.data.data", null),
        });
        break;
      }
      default: {
        throw error;
      }
    }
  }
);

export default axiosInstance;
